/**
 * 动态添加菜单
 * 
 */
const addMenus = {
  state: {
    menuList: [],
    jurisdict:[],
    userInfo:{}
  },
  mutations: {
    add_Menus(state, param) {
        if(param){
            var menuList=[];
             _addMenu(menuList,param);
             state.menuList=menuList; 
        }
        function _addMenu(menuList,params){
            
            for(var i=0;i<params.length;i++){
                 var menu={
                        icon: 'el-icon-tickets',
                        index: '1',
                        title: '工作台',
                        subs: [],
                        jurisdict:[]
                };
                var menuParam=params[i];
                //  if(menuParam.isShow==0){
                //     continue;
                // }
                menu.icon=menuParam.menuIcon;
                // menu.index=menuParam.orderBy;
                menu.index=menuParam.permission; 
                menu.title=menuParam.text;

                menu.jurisdict = menuParam.jurisdict

                if(menuParam.children&&menuParam.children.length>0){
                    _addMenu(menu.subs,menuParam.children);
                }
                menuList.push(menu);
            } 
        }
    },
    add_Jurisdict(state,param){
       state.jurisdict = param;
    },
    add_userInfo(state,param){
      state.userInfo = param;
    }
  },
  actions: {
    add_Menus({commit}, param) {
      commit('add_Menus', param)
    },
    add_Jurisdict({commit},param){
      commit('add_Jurisdict', param)
    },
    add_userInfo({commit},param){
      commit('add_userInfo', param)
    }
  }
}
export default addMenus


// WEBPACK FOOTER //
// ./src/store/components/addMenus.js